/**
 * Product availability countdown: D:H:M:S timer and purchase unlock.
 */
(function () {
  const COMPONENT_NAME = 'product-availability-countdown';

  const padTwo = (value) => String(value).padStart(2, '0');

  const parseCampaignDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') {
      return null;
    }

    let normalized = dateStr.trim();

    if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
      normalized = `${normalized}T00:00:00`;
    } else {
      normalized = normalized.replace(' ', 'T');
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(normalized)) {
        normalized = `${normalized}:00`;
      }
    }

    const parsed = new Date(normalized);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  };

  class ProductAvailabilityCountdown extends HTMLElement {
    constructor() {
      super();
      this.interval = null;
      this.endDate = null;
      this._onVisibilityChange = this._onVisibilityChange.bind(this);
    }

    connectedCallback() {
      this.endDate = parseCampaignDate(this.dataset.end);

      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');

      if (!this.endDate) {
        this.#unlockPurchase();
        return;
      }

      if (Date.now() >= this.endDate.getTime()) {
        this.#unlockPurchase();
        return;
      }

      this.#updateCountdown(Math.max(0, this.endDate.getTime() - Date.now()));
      this._start();
      document.addEventListener('visibilitychange', this._onVisibilityChange);
    }

    disconnectedCallback() {
      this._stop();
      document.removeEventListener('visibilitychange', this._onVisibilityChange);
    }

    _start() {
      if (this.interval) {
        return;
      }
      this.interval = window.setInterval(() => this.#tick(), 1000);
    }

    _stop() {
      if (!this.interval) {
        return;
      }
      window.clearInterval(this.interval);
      this.interval = null;
    }

    _onVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        this._stop();
        return;
      }

      this.#tick();
      this._start();
    }

    #tick() {
      const leftMs = Math.max(0, this.endDate.getTime() - Date.now());

      if (leftMs <= 0) {
        this.#unlockPurchase();
        return;
      }

      this.#updateCountdown(leftMs);
    }

    #updateCountdown(leftMs) {
      const totalSeconds = Math.floor(leftMs / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (this.daysEl) {
        this.daysEl.textContent = padTwo(days);
      }
      if (this.hoursEl) {
        this.hoursEl.textContent = padTwo(hours);
      }
      if (this.minutesEl) {
        this.minutesEl.textContent = padTwo(minutes);
      }
      if (this.secondsEl) {
        this.secondsEl.textContent = padTwo(seconds);
      }
    }

    #unlockPurchase() {
      this._stop();

      const productForm = this.closest('.product-form');
      if (productForm) {
        productForm.classList.add('product-form--availability-available');
      }

      const sectionId = this.dataset.sectionId;
      if (sectionId) {
        const sticky = document.querySelector(`product-sticky[data-section-id="${sectionId}"]`);
        if (sticky) {
          sticky.classList.add('Product-Sticky--availability-available');
        }
      }

      this.hidden = true;
    }
  }

  if (!customElements.get(COMPONENT_NAME)) {
    customElements.define(COMPONENT_NAME, ProductAvailabilityCountdown);
  }
})();